export const parseReturnValue = (value: string): boolean => value === 'true';

export const parseToggleValue = (isToggledOn: boolean): string => (isToggledOn ? 'true' : 'false');
